import React from "react";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { useLocation, useNavigate } from "react-router-dom";
import { OfferDealCategoryData, OfferFilteredDealsData } from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { onGetDealsReset } from "../../Store/Slices/dealsDataSlice";

const SelectedBrand = ({
  tagFilters,
  hiddenCategoryValues = [],
  setTagFilters,
  setIsModalOpen,
  setAppliedFilters,
  setActiveTab,
  isMobileView,
  setPageNo,
  setIsFetching
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translation = getTranslation();
  const allOfferData = useSelector((state) => state?.dealsDataSlice?.allofferData);
  const filteredDays = React.useMemo(() => allOfferData?.filteredDays, [allOfferData?.filteredDays]);
  const filteredDealCategories = React.useMemo(() => allOfferData?.filteredDealCategories, [allOfferData?.filteredDealCategories]);
  const filteredCategories = filteredDealCategories?.map(category => ({
    key: category.id,
    value: category.name
  }));
  const updateURLParams = (updatedFilters) => {
    const searchParams = new URLSearchParams(location.search);

    ["brand", "category", "validity", "offer"].forEach((key) =>
      searchParams.delete(key)
    );

    // Remove 'ctid' param from URL
    if (searchParams.has('ctid')) {
      searchParams.delete('ctid');
    }

    Object.keys(updatedFilters).forEach((key) => {
      if (updatedFilters[key].length) {
        updatedFilters[key].forEach((value) => searchParams.append(key, value));
      }
    });

    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true }
    );
  };

  const handleRemoveTag = (type, value) => {
    const updatedFilters = {
      ...tagFilters,
      [type]: tagFilters[type].filter((tag) => tag !== value),
    };
    setTagFilters(updatedFilters);
    setIsFetching(true);
    updateURLParams(updatedFilters);
    setAppliedFilters(updatedFilters, true);
    setPageNo(1);
  };
  const findValue = (key, arrayList) => {
    const itemName = arrayList?.find((item) => item?.key === parseInt(key));
    return itemName?.value
  }

  return (
    <div className={`select_brand_box ${isMobileView ? "pl-2 pr-2 mt-1" : ""}`}>
      <div className="brand_container">
        {tagFilters?.brand?.length > 0 && (
          <div className="brand_btn selct-mb">
            <span className="brand_qty">
              <span>{tagFilters.brand.length}</span>
            </span>
            <span className="brand_name">{translation?.brand}</span>

            {tagFilters.brand.length > 1 ? (
              <span
                className="select pl-1.5 ml-2.5 icon-down flex items-center"
                onClick={() => {
                  setActiveTab("Brand");
                  setIsModalOpen(true);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="down-arrow-icon"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path d="M12 17.27L18.18 12l-1.64-1.41L12 14.83l-4.54-4.24L5.82 12z" />
                </svg>
              </span>
            ) : (
              <span
                className="select px-1.5 ml-2.5 icon-cross"
                onClick={() => handleRemoveTag("brand", tagFilters.brand[0])}
              >
                <i className="fa-solid fa-xmark"></i>
              </span>
            )}
          </div>
        )}

        {/* Category Filter */}
        {tagFilters?.category
          ?.filter((category) =>
            String(category) !== "all" &&
            !hiddenCategoryValues.includes(String(category))
          )
          ?.map((category, index) => (
          <div key={index} className="brand_btn selct-mb">
            <span className="brand_name">{findValue(category, filteredCategories)}</span>
            <span
              className="select px-1.5 ml-2.5 icon-cross-cat"
              onClick={() => handleRemoveTag("category", category)}
            >
              <i className="fa-solid fa-xmark"></i>
            </span>
          </div>
        ))}

        {/* Validity Filter */}
        {tagFilters?.validity?.map((validity, index) => {
          // const lastWord = validity.split(" ").pop();
          return (
            <div key={index} className="brand_btn selct-mb">
              <span className="brand_name">{findValue(validity, filteredDays)}</span>
              <span
                className="select px-1.5 ml-2.5 icon-cross-cat"
                onClick={() => handleRemoveTag("validity", validity)}
              >
                <i className="fa-solid fa-xmark"></i>
              </span>
            </div>
          );
        })}
        {tagFilters?.offer?.map((validity, index) => {
          const lastWord = validity.split(" ").pop();
          return (
            <div key={index} className="brand_btn selct-mb">
              <span className="brand_name">{lastWord}</span>
              <span
                className="select px-1.5 ml-2.5 icon-cross-cat"
                onClick={() => handleRemoveTag("offer", validity)}
              >
                <i className="fa-solid fa-xmark"></i>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedBrand;
